import SolicitudService from 'src/modules/solicitud/solicitudService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'SOLICITUD_FORM';

const solicitudFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: solicitudFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await SolicitudService.find(id);
      }

      dispatch({
        type: solicitudFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: solicitudFormActions.INIT_ERROR,
      });

      getHistory().push('/solicitud');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: solicitudFormActions.CREATE_STARTED,
      });

      await SolicitudService.create(values);

      dispatch({
        type: solicitudFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.solicitud.create.success'),
      );

      getHistory().push('/solicitud');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: solicitudFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: solicitudFormActions.UPDATE_STARTED,
      });

      await SolicitudService.update(id, values);

      dispatch({
        type: solicitudFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.solicitud.update.success'),
      );

      getHistory().push('/solicitud');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: solicitudFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default solicitudFormActions;
